// extracted by mini-css-extract-plugin
export default {"layout":"style_layout__1EN8i","contentWrapper":"style_contentWrapper__0x-1D","mainContent":"style_mainContent__XLI2V","withSidebar":"style_withSidebar__1aztl"};